import React from "react";
import { Stack } from "@mui/material";

interface ICenteredContentProps {
  children: React.ReactNode;
}

const CenteredContent = ({ children }: ICenteredContentProps) => (
  <Stack
    justifyContent="center"
    alignItems="center"
    position="fixed"
    top="50%"
    left="50%"
    sx={{ transform: "translate(-50%, -50%)" }}
  >
    {children}
  </Stack>
);

export default CenteredContent;